export default "__VITE_ASSET__Ci1sM5tS__"